export default {
	rights: {
		title: 'Rights Management',
		operatorManage: 'Operator management',
		roleManage: 'Role management',
		groupLabel: 'Group',
		roleLabel: 'Role',
		statusLabel: 'Status',
		nameLabel: 'Name',
		usernameLabel: 'Username',
		phoneLabel: 'Phone',
		emailLabel: 'Email',
		createNewOperator: 'CREATE NEW OPERATOR',
		search: 'SEARCH',
		clear: 'CLEAR ALL',
		lastLoginTime: 'Last login time',
		operator: 'Operator',
		action: 'Action',
		detail: 'Detail',
		notAssigned: 'Not assigned',
		seeAll: 'See all',
		collapse: 'Collapse',
		all: 'ALL',
		statusTrue: 'Enable',
		statusFalse: 'Disable',
		phoneEmail: 'Phone & email',
		roleName: 'Role name',
		createNewRole: 'CREATE NEW ROLE',
		roleDesc: 'Role description',
		updateTime: 'Update time',
		delete: 'Delete',
		tips: 'Are you sure you want to disable this operator? This operator will not be able to log in to the background?',
		tips1: 'Are you sure you want to enable this operator? ',
		displayOp: 'Disable the operator',
		enabledOp: 'Enable the operator',
		enabled: 'Enable',
		sure: 'Disable',
		cancel: 'Cancel',
		tips2: 'Delete the role',
		tips3: 'Are you sure to delete the role',
		tips4: 'There are operators in use this role.Are you sure to delete the role',
		tipTitle: 'Tips'
	},
	detail: {
		operatorDetail: 'Operatpr Detail',
		resetPassword: 'Reset password',
		editOperator: 'Edit operator',
		delOperator: 'Delete operator',
		delOperatorTip: 'This operation will delete the operator. Do you want to continue?',
		operatorName: 'Operator name',
		affiliatedGroup: 'Group',
		roleInfo: 'Role information',
		create: 'Create time',
		roleDetail: 'Role Detail',
		roleManage: 'Role management',
		rolePermission: 'Role permissions',
		operatorInfo: 'Operator information',
		edit: 'Edit'

	},
	edit: {
		editOperator: 'Edit Operator',
		createOperator: 'Create New Operator',
		basicInfo: 'Basic information',
		tips: 'Operators can only see the data of groups they assigned',
		allgroups: 'All groups',
		tips2: ' This option includes the groups you are going to create in the future.',
		groupNotAssigned: 'Group not assigned',
		groupAssigned: 'Group assigned',
		roleInfo: 'Role information',
		tips3: 'After the role is assigned, the operator will get the function permission of this role.',
		save: 'SAVE',
		cancel: 'CANCEL',
		create: 'CREATE',
		tips4: 'Once the operator created, the name cannot be modified',
		password: 'Password',
		repeatPassword: 'Confirm password',
		errorPwd: 'The password must start with English and contain any two types of numbers, uppercase and lowercase letters, 6-20 characters',
		errorName: 'Please enter name',
		errorUsername: 'Please enter username',
		errorPhone: 'Please enter phone number',
		errorPhoneRNM: 'Please enter currect phone number',
		errorEmail: 'Please enter email',
		errorEmailFm: 'Please enter currect email address',
		errorPassword: 'Please enter password',
		errorRepeatPassword: 'Please repeat password',
		errorRoleName: 'Please enter role name',
		errorRoleDesc: 'Please enter role description',
		difPassword: 'Password do not match.',
		saveSuccess: 'save successfully',
		addSuccess: 'add successfully',
		delSuccess: 'delete successfully',
		editRole: 'Edit Role',
		createRole: 'Create New Role',
		tip5: 'The permission setting is accurate to the button level. If the button permission is not checked, the operator cannot click the button to operate. After adding the permission, the operator will have the page and button display and operation permission.',
		resetPwd: 'Reset the passeword',
		newPwd: 'New password',
		confirmPwd: 'Confirm password',
		reset: 'Reset',
		checkAll: 'Check All',
		roles: 'Distribute Role',
		repeatName: 'Duplicate operator name',
		repeatLogin: 'Duplicate login name',
		repeatPhone: 'Duplicate phone number',
		repeatEmail: 'Duplicate mailbox',
		editSuccess: 'Edit successfully'

	}
}
